import { useCallback, useEffect } from "react"
import { aIsFullscreen, useAtom } from "~/atoms"

function hasTouchSupport() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0
}

interface FullScreenable extends HTMLVideoElement {
  webkitEnterFullScreen: () => void
}

export default function useToggleFullscreen() {
  const [isFullscreen, setIsFullscreen] = useAtom(aIsFullscreen)

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
    }
    document.addEventListener("fullscreenchange", onFullscreenChange)
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleFullscreen = useCallback(() => {
    if (document.fullscreenElement === null) {
      const video = (
        hasTouchSupport()
          ? document.getElementsByTagName("video")[0]
          : document.getElementById("player-container")
      ) as FullScreenable
      if (typeof video.webkitEnterFullScreen !== "undefined") {
        video.webkitEnterFullScreen()
      } else if (typeof video.requestFullscreen !== "undefined") {
        video.requestFullscreen()
      }
    } else {
      document.exitFullscreen()
    }
  }, [])

  return { isFullscreen, toggleFullscreen }
}
